import { useEffect, useRef, useState } from "react";

import * as Clipboard from "expo-clipboard";

type UseCopyToClipboardOptions = {
  resetMs?: number;
};

export function useCopyToClipboard(
  value: string,
  options: UseCopyToClipboardOptions = {}
) {
  const { resetMs = 1200 } = options;
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  const copy = async () => {
    try {
      await Clipboard.setStringAsync(value);
    } catch {
      try {
        if (
          typeof navigator !== "undefined" &&
          navigator.clipboard?.writeText
        ) {
          await navigator.clipboard.writeText(value);
        }
      } catch {
        // ignore
      }
    }

    setCopied(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setCopied(false), resetMs);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { copy, copied };
}
